export var ProjectsFilterByOwnerLabels;
(function (ProjectsFilterByOwnerLabels) {
    ProjectsFilterByOwnerLabels["ALL_PROJECTS"] = "All projects";
    ProjectsFilterByOwnerLabels["MY_PROJECTS"] = "My projects";
})(ProjectsFilterByOwnerLabels || (ProjectsFilterByOwnerLabels = {}));
